import React from 'react'

import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Button } from '@termly-web/react-components'

import Styles from './styles.scss'


export default function TextLink(props) {
  const {
    children,
    className,
    handleClick,
    'data-tid': dataTid,
    ...otherProps
  } = props

  const onClick = (e) => {
    if ( !handleClick ) {
      return
    }

    e.stopPropagation()

    handleClick()
  }

  // The role=button form must activate on both Enter and Space, matching a
  // native button: Enter fires on keydown, Space on keyup (with the keydown
  // default suppressed so the page doesn't scroll). The anchor form keeps its
  // native keyboard behavior, so we leave its events untouched.
  //
  const onKeyDown = (e) => {
    if ( !handleClick ) {
      return
    }

    if ( e.key === 'Enter' ) {
      e.preventDefault()

      onClick(e)
    } else if ( e.key === ' ' ) {
      e.preventDefault()
    }
  }

  const onKeyUp = (e) => {
    if ( !handleClick || e.key !== ' ' ) {
      return
    }

    e.preventDefault()

    onClick(e)
  }

  const rootClassName = classnames(Styles.root, className)

  const Tag = ( handleClick ) ? 'span' : 'a'
  const role = ( handleClick ) ? 'button' : 'link'

  return (
    <Tag
      className={ rootClassName }
      data-tid={ dataTid }
      onClick={ onClick }
      onKeyDown={ onKeyDown }
      onKeyUp={ onKeyUp }
      role={ role }
      tabIndex={ 0 }
      { ...otherProps }
    >
      { children }
    </Tag>
  )
}

TextLink.propTypes = {
  children: PropTypes.node.isRequired,

  'data-tid': PropTypes.string,
  className: PropTypes.string,
  handleClick: Button.propTypes.handleClick,
  href: PropTypes.string,
}
